import store from '@/store';
import axios from 'axios';
import {
  authHeader
} from './../_helpers/_auth-header';

export const userService = {
  login,
  logout,
  register,
  getAll,
  getById,
  update,
  delete: _delete,
  handleErrorResponseAxios
};

function login(username, password) {
    let url = store.state.urlBase + '/api/auth/login';

    let options = {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
        },
    };
    let form = {
        username: username,
        password: password
    }
    return axios.post(url, form, options)
        .then(response => {
            let data = response.data;
            // console.log(data);
            if (data.access_token) {
                let token = data.access_token; 
                // localStorage.setItem('userToken', token); // se realiza en el commit:setUser
                // let user = atob(token.split('.')[1])
                // localStorage.setItem('user', user);
                console.log('user.service.login validado!');
            }
            return data;
        })
        // .catch(handleErrorResponseAxios);
}


function login2(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      username,
      password
    })
  };

  return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
      }

      return user;
    });
}

function logout() {
  let url = store.state.urlBase + '/api/auth/logout';
  let headers = {
    ...{
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    }, 
    ...authHeader()
  }
  let options = {
    headers
  };

  // return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse);
  return axios.get(url, options)
    .then(response => {
      // console.log(response);
      if (response.data) {
        cleanLocalUser();
        console.log('Logout exitoso!');
      }
      return response.data;
    })
    .catch(error => {
      cleanLocalUser();
      console.log('Error logout:', error);
    })
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse);
}


function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/users/${user.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function cleanLocalUser() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
  localStorage.removeItem('userToken');
  localStorage.removeItem('userDetails')
  console.log('borrado LocalUser');
}


function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        cleanLocalUser();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}


function handleErrorResponseAxios(error) {
  console.log('handle error response axios :', error.response)
  if (error.response.status === 401) {
    // auto logout if 401 response returned from api
    cleanLocalUser();
    location.reload(true);
  }
  return Promise.reject(error);
  // return data;
}

/* 
axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
  if (error.response.status === 401) {
    console.log('unauthorized, logging out ...');
    auth.logout();
    router.replace('/auth/login');
  }
  return Promise.reject(error.response);
}); 
*/